
import {
  getSecretKey,
  // fetchContactList,
  fetchCardTypeList,
  fetchContactDetail,
  fetch12306ContactDetail,
  checkPermission,
  getGroupCountry
} from '../../../api/contact'

export async function getSecretKeyAction ({ commit }, payload) {
  try {
    const { data: { secret_key } } = await getSecretKey(payload);
    commit('secretKeySuccess', { secret_key });
    return secret_key;
  } catch (e) {
    console.log(e)
  }
}

// export async function getContactListAction ({ commit }, payload) {
//   try {
//     const { data } = await fetchContactList(payload);
//     commit('contactListSuccess', { data });
//     return data;
//   } catch (e) {
//     console.log(e)
//   }
// }

export async function getCardTypeListAction ({ commit }, payload) {
  try {
    const { data } = await fetchCardTypeList(payload);
    // 2023.06.04, 接口 404, 暂使用 mock 数据, 后续可删
    // const data = {
    //   list: [
    //    {
    //     code: '1',
    //     name: '中国居民身份证'
    //    },
    //    {
    //     code: '2',
    //     name: '港澳台居民居住证'
    //    },
    //    {
    //     code: 'B',
    //     name: '护照'
    //    },
    //    {
    //     code: 'C',
    //     name: '港澳居民来往内地通行证'
    //    },
    //    {
    //     code: 'G',
    //     name: '台湾居民来往大陆通行证'
    //    },
    //    {
    //     code: 'H',
    //     name: '外国人永久居留证'
    //    },
    //   ]
    // }
    if (data) {
      commit('cardTypeListSuccess', { data });
    }
    return data;
  } catch (e) {
    console.log(e)
  }
}

export async function getContactDetailAction ({ commit }, payload) {
  const { isNewDate } = payload
  try {
    const res = await fetch12306ContactDetail(payload);
    if (+res.code === 0) {
      if(isNewDate){
        res.data.isNewDate = true
      }
      commit('contactDetailSuccess', { data: res.data });
    }
    return res;
  } catch (e) {
    console.log(e)
  }
}

export async function checkPermissionAction ({ commit }, payload) {
  try {
    const res = await checkPermission(payload);
    if (res.code === 0) {
      commit('checkPermissionSuccess', { data: res.data });
    }
    return res;
  } catch (e) {
    console.log(e)
  }
}

export function deleteContactDetailAction({ commit }, payload) {
  setTimeout(() => {
    commit('contactDetailSuccess', { data: {
      id: payload.id,
      isDel: true,
    }});
  }, 300);
}

export async function getGroupCountryAction({ commit }, payload) {
  try {
    const res = await getGroupCountry();
    if (res.code == 0) {
      commit('setGroupCountry', { ...res?.data?.country_list ?? {} });
    }
    return res;
  } catch (e) {
    console.log(e)
  }
}

export default {
  getSecretKeyAction,
  // getContactListAction,
  getCardTypeListAction,
  getContactDetailAction,
  checkPermissionAction,
  deleteContactDetailAction,
  getGroupCountryAction
}
